let language = {
    // 请求ps运费服务报错
    "4000032": "Failed to call freight pricing service, click ok to retry again.",
    // 请求ps运费计算预计到达时间错误
    "4000033": "Failed to call freight pricing service, click ok to retry again.",
    // 税费计算报错
    "4000041": "Failed to call freight pricing service, click ok to retry again."
};

export { language }